import React from "react";
import { Button, HStack } from "@chakra-ui/react";

export const simulatorEditCancelColor = "#E00101";

export const simulatorEditSaveButtonProps = {
  size: "sm",
  px: "20px",
  h: "32px",
  minH: "32px",
  py: 0,
  lineHeight: "1",
  fontSize: "xs",
  fontFamily: "'IBM Plex Sans', sans-serif",
  fontWeight: "medium",
  textTransform: "uppercase",
  borderRadius: "8px",
  bgGradient: "linear-gradient(135deg, #38BBD1, #3EEAEC)",
  color: "white",
  _hover: { opacity: 0.9 },
  _active: { opacity: 0.85 },
} as const;

export const simulatorEditCancelButtonProps = {
  size: "sm",
  px: "20px",
  h: "32px",
  minH: "32px",
  py: 0,
  lineHeight: "1",
  fontSize: "xs",
  fontFamily: "'IBM Plex Sans', sans-serif",
  fontWeight: "medium",
  textTransform: "uppercase",
  borderRadius: "8px",
  variant: "outline",
} as const;

const ButtonAny = Button as unknown as React.FC<any>;
const HStackAny = HStack as unknown as React.FC<any>;

/** Save / Cancel pair used for simulation title and policy group name edits. */
export function SimulatorInlineEditActions(props: {
  onSave: () => void;
  onCancel: () => void;
}): React.ReactElement {
  return (
    <HStackAny spacing={2} flexShrink={0} flexWrap="nowrap" align="flex-end">
      <ButtonAny
        type="button"
        {...simulatorEditSaveButtonProps}
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={props.onSave}
      >
        Save
      </ButtonAny>
      <ButtonAny
        type="button"
        {...simulatorEditCancelButtonProps}
        color={simulatorEditCancelColor}
        borderColor={simulatorEditCancelColor}
        _hover={{
          borderColor: simulatorEditCancelColor,
          color: simulatorEditCancelColor,
          opacity: 0.88,
          bg: "rgba(224, 1, 1, 0.06)",
        }}
        _active={{ opacity: 0.8 }}
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={props.onCancel}
      >
        Cancel
      </ButtonAny>
    </HStackAny>
  );
}
